var _rect, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTutorOverlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.1875,
    y: 8.1875,
    width: 23.625,
    height: 23.625,
    rx: 11.8125,
    fill: "url(#paint0_radial_1347_89677)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddi_1347_89677)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0127 20C8.0127 12.268 14.269 6 21.9865 6C29.7041 6 35.9604 12.268 35.9604 20C35.9604 27.732 29.7041 34 21.9865 34H10.8948C10.7969 33.9966 10.6898 33.994 10.5773 33.9913C9.74051 33.9712 8.60882 33.944 8.79872 33.5275C8.96556 33.1616 9.24531 32.8248 9.54273 32.4668C10.3975 31.4378 11.3982 30.233 10.285 27.6554C10.0981 27.2228 9.92259 26.823 9.75843 26.4492C8.60412 23.8205 8.0127 22.4736 8.0127 20ZM21.9745 8.46442C15.6155 8.46442 10.4604 13.641 10.4604 20C10.4604 26.359 15.6155 31.5356 21.9745 31.5356C28.3335 31.5356 33.4885 26.359 33.4885 20C33.4885 13.641 28.3335 8.46442 21.9745 8.46442Z",
    fill: "url(#paint1_linear_1347_89677)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0127 20C8.0127 12.268 14.269 6 21.9865 6C29.7041 6 35.9604 12.268 35.9604 20C35.9604 27.732 29.7041 34 21.9865 34H10.8948C10.7969 33.9966 10.6898 33.994 10.5773 33.9913C9.74051 33.9712 8.60882 33.944 8.79872 33.5275C8.96556 33.1616 9.24531 32.8248 9.54273 32.4668C10.3975 31.4378 11.3982 30.233 10.285 27.6554C10.0981 27.2228 9.92259 26.823 9.75843 26.4492C8.60412 23.8205 8.0127 22.4736 8.0127 20ZM21.9745 8.46442C15.6155 8.46442 10.4604 13.641 10.4604 20C10.4604 26.359 15.6155 31.5356 21.9745 31.5356C28.3335 31.5356 33.4885 26.359 33.4885 20C33.4885 13.641 28.3335 8.46442 21.9745 8.46442Z",
    fill: "url(#paint2_radial_1347_89677)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0127 20C8.0127 12.268 14.269 6 21.9865 6C29.7041 6 35.9604 12.268 35.9604 20C35.9604 27.732 29.7041 34 21.9865 34H10.8948C10.7969 33.9966 10.6898 33.994 10.5773 33.9913C9.74051 33.9712 8.60882 33.944 8.79872 33.5275C8.96556 33.1616 9.24531 32.8248 9.54273 32.4668C10.3975 31.4378 11.3982 30.233 10.285 27.6554C10.0981 27.2228 9.92259 26.823 9.75843 26.4492C8.60412 23.8205 8.0127 22.4736 8.0127 20ZM21.9745 8.46442C15.6155 8.46442 10.4604 13.641 10.4604 20C10.4604 26.359 15.6155 31.5356 21.9745 31.5356C28.3335 31.5356 33.4885 26.359 33.4885 20C33.4885 13.641 28.3335 8.46442 21.9745 8.46442Z",
    fill: "url(#paint3_radial_1347_89677)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0127 20C8.0127 12.268 14.269 6 21.9865 6C29.7041 6 35.9604 12.268 35.9604 20C35.9604 27.732 29.7041 34 21.9865 34H10.8948C10.7969 33.9966 10.6898 33.994 10.5773 33.9913C9.74051 33.9712 8.60882 33.944 8.79872 33.5275C8.96556 33.1616 9.24531 32.8248 9.54273 32.4668C10.3975 31.4378 11.3982 30.233 10.285 27.6554C10.0981 27.2228 9.92259 26.823 9.75843 26.4492C8.60412 23.8205 8.0127 22.4736 8.0127 20ZM21.9745 8.46442C15.6155 8.46442 10.4604 13.641 10.4604 20C10.4604 26.359 15.6155 31.5356 21.9745 31.5356C28.3335 31.5356 33.4885 26.359 33.4885 20C33.4885 13.641 28.3335 8.46442 21.9745 8.46442Z",
    fill: "url(#paint4_radial_1347_89677)",
    fillOpacity: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1347_89677)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5807 16.5C16.4519 16.5 16.3474 16.6045 16.3474 16.7333C16.3474 16.8622 16.4519 16.9667 16.5807 16.9667H18.4941C18.6229 16.9667 18.7274 16.8622 18.7274 16.7333C18.7274 16.6045 18.6229 16.5 18.4941 16.5H16.5807ZM15.6239 17.4336C15.3662 17.4336 15.1572 17.6425 15.1572 17.9002C15.1572 18.158 15.3662 18.3669 15.6239 18.3669H19.4506C19.7083 18.3669 19.9172 18.158 19.9172 17.9002C19.9172 17.6425 19.7083 17.4336 19.4506 17.4336H15.6239ZM14.5625 19.2999C14.5625 19.0422 14.7714 18.8332 15.0292 18.8332H20.0458C20.3036 18.8332 20.5125 19.0422 20.5125 19.2999C20.5125 19.5576 20.3036 19.7665 20.0458 19.7665H15.0292C14.7714 19.7665 14.5625 19.5576 14.5625 19.2999ZM15.0292 20.2332C14.7714 20.2332 14.5625 20.4422 14.5625 20.6999C14.5625 20.9576 14.7714 21.1666 15.0292 21.1666H20.0458C20.3036 21.1666 20.5125 20.9576 20.5125 20.6999C20.5125 20.4422 20.3036 20.2332 20.0458 20.2332H15.0292ZM15.1572 22.1C15.1572 21.8423 15.3662 21.6334 15.6239 21.6334H19.4506C19.7083 21.6334 19.9172 21.8423 19.9172 22.1C19.9172 22.3577 19.7083 22.5667 19.4506 22.5667H15.6239C15.3662 22.5667 15.1572 22.3577 15.1572 22.1ZM16.5807 23.0335C16.4519 23.0335 16.3474 23.1379 16.3474 23.2668C16.3474 23.3957 16.4519 23.5001 16.5807 23.5001H18.4941C18.6229 23.5001 18.7274 23.3957 18.7274 23.2668C18.7274 23.1379 18.6229 23.0335 18.4941 23.0335H16.5807Z",
    fill: "#62FFEE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1347_89677)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5055 16.5C25.3767 16.5 25.2722 16.6045 25.2722 16.7333C25.2722 16.8622 25.3767 16.9667 25.5055 16.9667H27.4189C27.5478 16.9667 27.6522 16.8622 27.6522 16.7333C27.6522 16.6045 27.5478 16.5 27.4189 16.5H25.5055ZM24.5487 17.4336C24.291 17.4336 24.082 17.6425 24.082 17.9002C24.082 18.158 24.291 18.3669 24.5487 18.3669H28.3754C28.6331 18.3669 28.842 18.158 28.842 17.9002C28.842 17.6425 28.6331 17.4336 28.3754 17.4336H24.5487ZM23.4873 19.2999C23.4873 19.0422 23.6962 18.8332 23.954 18.8332H28.9706C29.2284 18.8332 29.4373 19.0422 29.4373 19.2999C29.4373 19.5576 29.2284 19.7665 28.9706 19.7665H23.954C23.6962 19.7665 23.4873 19.5576 23.4873 19.2999ZM23.954 20.2332C23.6962 20.2332 23.4873 20.4422 23.4873 20.6999C23.4873 20.9576 23.6962 21.1666 23.954 21.1666H28.9706C29.2284 21.1666 29.4373 20.9576 29.4373 20.6999C29.4373 20.4422 29.2284 20.2332 28.9706 20.2332H23.954ZM24.082 22.1C24.082 21.8423 24.291 21.6334 24.5487 21.6334H28.3754C28.6331 21.6334 28.842 21.8423 28.842 22.1C28.842 22.3577 28.6331 22.5667 28.3754 22.5667H24.5487C24.291 22.5667 24.082 22.3577 24.082 22.1ZM25.5055 23.0335C25.3767 23.0335 25.2722 23.1379 25.2722 23.2668C25.2722 23.3957 25.3767 23.5001 25.5055 23.5001H27.4189C27.5478 23.5001 27.6522 23.3957 27.6522 23.2668C27.6522 23.1379 27.5478 23.0335 27.4189 23.0335H25.5055Z",
    fill: "#62FFEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddi_1347_89677",
    x: 0.0126953,
    y: 0,
    width: 43.9473,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1347_89677"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1347_89677",
    result: "effect2_dropShadow_1347_89677"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1347_89677",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_1347_89677"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1347_89677",
    x: 6.5625,
    y: 8.5,
    width: 21.9502,
    height: 23.0001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.384314 0 0 0 0 1 0 0 0 0 0.933333 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1347_89677"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1347_89677",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1347_89677",
    x: 15.4873,
    y: 8.5,
    width: 21.9502,
    height: 23.0001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.384314 0 0 0 0 1 0 0 0 0 0.933333 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1347_89677"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1347_89677",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1347_89677",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22 20) rotate(90) scale(11.8125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1347_89677",
    x1: 35.9604,
    y1: 3.05797,
    x2: 9.82188,
    y2: 36.3801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7041EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527788,
    stopColor: "#8D41EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D641EE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1347_89677",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5917 -0.086957) rotate(96.1469) scale(34.2841 57.0441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F41EE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1347_89677",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.4733 7.62319) rotate(62.2447) scale(13.986 40.1009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DD6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F41EE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1347_89677",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.2236 27.4058) rotate(144.277) scale(23.6305 32.5212)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5263FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F41EE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorOverlay);
export default __webpack_public_path__ + "static/media/tutor-overlay.a4f0dd0610a47f180b47feb89b1df07b.svg";
export { ForwardRef as ReactComponent };